import { render, staticRenderFns } from "./ItemWidgetTitleLeaf.vue?vue&type=template&id=4c0afa0e&scoped=true&"
import script from "./ItemWidgetTitleLeaf.vue?vue&type=script&lang=js&"
export * from "./ItemWidgetTitleLeaf.vue?vue&type=script&lang=js&"
import style0 from "./ItemWidgetTitleLeaf.vue?vue&type=style&index=0&id=4c0afa0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0afa0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Touch from 'vuetify/lib/directives/touch'
installDirectives(component, {Touch})
